<template>
  <div>
    <div class="container">
      <el-form :inline="false" label-width="90px" label-position="left" class="demo-form-inline" size="mini">
        <el-form-item label="储值订单号">
          <el-col span="5">
            <el-input placeholder="请输入储值订单号" v-model="params.id"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-col span="5">
            <el-input placeholder="输入用户手机号" v-model="params.usermobile"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker :picker-options="pickerOptions" end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" type="daterange" unlink-panels v-model="params.time"></el-date-picker>
        </el-form-item>
      </el-form>
      <el-button @click="onClickFilter" size="small">筛选</el-button>
      <el-button @click="clearFilter" style="color: #4E759E;" size="small" type="text">清空筛选条件</el-button>
    </div>
    <div class="container">
      <el-table :data="list">
        <el-table-column label="ID" prop="id"></el-table-column>
        <el-table-column label="昵称" prop="user.nickname"></el-table-column>
        <el-table-column label="手机号" prop="user.mobile"></el-table-column>
        <el-table-column label="储值金额">
          <template slot-scope="scope">
            <span style="color:#ff4f4f">{{ scope.row.recharge.amount / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="赠送金额">
          <template slot-scope="scope">
            <span>{{ scope.row.recharge.gift / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="储值时间">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.paidat * 1000).toLocaleString() }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-bottom">
        <el-button v-if="hasMore" :loading="loadmore" @click="getList" size="small" type="primary">加载更多</el-button>
        <span style="color: #ccc; font-size: 12px;" v-else>已加载全部，没有更多了</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
const pickerOptions = {
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }
  ]
};

export default {
  data() {
    return {
      token: '',
      pickerOptions,
      params: {
        id: '',
        count: 20,
        idlessthan: 0,
        userid: 0,
        status: 2,
        usermobile: '',
        createdatgreaterthan: 0,
        createdatlessthan: 0,
        time: []
      },
      list: [],
      loadmore: false,
      hasMore: true
    };
  },
  created() {
    this.token = getToken();
    this.getList();
  },
  methods: {
    onClickFilter() {
      this.list = [];
      this.getList();
    },

    clearFilter() {
      this.params = {
        id: '',
        count: 20,
        idlessthan: 0,
        userid: 0,
        status: 2,
        usermobile: '',
        createdatgreaterthan: 0,
        createdatlessthan: 0,
        time: []
      };
      this.list = [];
      this.getList();
    },

    async getList() {
      this.loadmore = true;
      const { scrollY } = window;
      this.params.userid = 0;
      if (this.params.usermobile) {
        const res0 = await rpc(
          'StoreUserService.GetUserList',
          M('UserListQueryRequest', {
            token: M('Token', { token: this.token }),
            mobile: this.params.usermobile,
            count: 1,
            order: 0
          })
        );
        if (!res0.userlistList.length) {
          this.hasMore = 0;
          this.loadmore = false;
          return;
        }
        this.params.userid = res0.userlistList[0].id;
      }
      this.params.createdatgreaterthan = 0;
      this.params.createdatlessthan = 0;
      if (this.params.time.length == 2) {
        this.params.createdatgreaterthan = parseInt(this.params.time[0].getTime() / 1000);
        this.params.createdatlessthan = parseInt(this.params.time[1].getTime() / 1000);
      }
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;

      const res = await rpc(
        'StoreRechargeOrderService.GetRechargeOrderList',
        M('RechargeOrderListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      const useridlist = res.rechargeorderlistList.map(v => v.userid);
      const rechargeidlist = res.rechargeorderlistList.map(v => v.rechargeid);
      const reslist = await Promise.all([
        rpc(
          'StoreUserService.GetUserList',
          M('UserListQueryRequest', {
            token: M('Token', { token: this.token }),
            idlistList: useridlist,
            count: useridlist.length,
            order: 0
          })
        ),
        rpc(
          'StoreRechargeService.GetRechargeList',
          M('RechargeListQueryRequest', {
            token: M('Token', { token: this.token }),
            idlistList: rechargeidlist,
            count: rechargeidlist.length,
            sortby: 1,
            sort1: 1
          })
        )
      ]);
      res.rechargeorderlistList.forEach(item => {
        item.user = reslist[0].userlistList.find(v => v.id == item.userid);
        item.recharge = reslist[1].rechargelistList.find(v => v.id == item.rechargeid);
      });

      this.list = this.list.concat(res.rechargeorderlistList);
      this.hasMore = res.rechargeorderlistList.length;
      if (this.params.idlessthan !== 0) {
        window.scroll(0, scrollY);
      }
      this.loadmore = false;
    }
  }
};
</script>

<style></style>
